import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "vc-day-inside" }
const _hoisted_2 = { class: "vc-day-entries" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "vc-appointment-title" }
const _hoisted_5 = {
  key: 0,
  class: "vc-appointment-subtitle"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "vc-appointment-start" }
const _hoisted_8 = {
  key: 2,
  class: "vc-appointment-location",
  style: {"margin-top":"5px!important"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "location-svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z",
    stroke: "#FFFFFF",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z",
    stroke: "#FFFFFF",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_10 = { class: "location-name" }
const _hoisted_11 = { class: "vc-appointment-cta" }
const _hoisted_12 = ["src", "srcset"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Jetzt anmelden ")
const _hoisted_14 = {
  key: 0,
  class: "no-appointments-overlay"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "no-appointments-label" }, "Keine Kurse diesen Monat", -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_AppointmentDetailModal = _resolveComponent("AppointmentDetailModal")!
  const _component_CourseEnrollmentModal = _resolveComponent("CourseEnrollmentModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bf-calendar-appointments overflow-hidden", {'bf-calendar--no-appointments': !_ctx.hasAppointmentsInDisplayedMonth}])
  }, [
    _createVNode(_component_Calendar, {
      class: "custom-calendar max-w-full",
      masks: _ctx.masks,
      attributes: _ctx.attributes,
      "min-date": _ctx.minDate,
      "max-date": _ctx.maxDate,
      "onUpdate:fromPage": _ctx.onMonthChange,
      "disable-page-swipe": "",
      "is-expanded": ""
    }, {
      "day-content": _withCtx(({ day, attributes }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            class: _normalizeClass(["vc-day-label", {'vc-day-label--today': (attributes || []).some(attr => attr?.highlight)}])
          }, _toDisplayString(day.day), 3),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((attributes || []).filter(attr => attr?.customData?.type === 'appointment'), (attr) => {
              return (_openBlock(), _createElementBlock("div", {
                key: attr.key,
                class: _normalizeClass(["vc-appointment", attr.customData.class]),
                style: _normalizeStyle(`background-color:#${attr.customData?.color}`),
                onClick: ($event: any) => (_ctx.onAppointmentClick(attr.customData?.id, attr.customData))
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(attr.customData.title), 1),
                (attr.customData?.subtitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(attr.customData.subtitle), 1))
                  : _createCommentVNode("", true),
                (attr?.customData?.mode === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, " Start: " + _toDisplayString(attr?.customData?.startDate), 1)
                    ]))
                  : _createCommentVNode("", true),
                (attr?.customData?.location)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("span", _hoisted_10, _toDisplayString(attr.customData.location.name), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    style: {"filter":"brightness(0) invert(1)"},
                    src: _ctx.assetsBaseUrl + '/img/fast-forward.svg',
                    srcset: `${_ctx.assetsBaseUrl}/fast-forward.svg 1x, ${_ctx.assetsBaseUrl}/img/fast-forward.svg 2x`,
                    alt: "",
                    title: ""
                  }, null, 8, _hoisted_12),
                  _hoisted_13
                ])
              ], 14, _hoisted_3))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["masks", "attributes", "min-date", "max-date", "onUpdate:fromPage"]),
    (!_ctx.hasAppointmentsInDisplayedMonth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
      : _createCommentVNode("", true),
    _createVNode(_component_AppointmentDetailModal, {
      appointment: _ctx.currentModalAppointment,
      shown: _ctx.modalAppointmentShown,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalAppointmentShown = false))
    }, null, 8, ["appointment", "shown"]),
    _createVNode(_component_CourseEnrollmentModal, {
      course: _ctx.currentModalCourse,
      shown: _ctx.modalCourseShown,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalCourseShown = false))
    }, null, 8, ["course", "shown"])
  ], 2))
}